export default __webpack_public_path__ + "static/media/Loovers-punti-utente-junior.2966029b.png";